export default __webpack_public_path__ + "static/media/my_todo_list.eb628869.jpg";